module.exports = __webpack_public_path__ + "img/music-slash.71ad18e6.svg";